import React, { useEffect } from "react";
import $ from "jquery";
import { NavLink } from "react-router-dom";

export const Header = () => {
	const handleClick = (e) => {
		e.preventDefault();
	};
	useEffect(() => {
		$('[data-toggle="tooltip"]').tooltip();
	}, []);

	return (
		<div className="container-fluid">
			<nav className="navbar navbar-expand-md navbar-light px-0 mb-2">
				<h1 className="sr-only visually-hidden">Events: navigation</h1>
				<button className="btn-icon btn-alert bg-white navbar-toggler border-0 mx-auto rounded-max px-1" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
					<span className="btn-alert-primary eva eva-menu-outline rounded-inherit my-auto lh-1 fs-sm p-2"></span>
					<span className="text-gray h6 lh-1 my-auto ml-2 mr-3">Menu</span>
				</button>
				<div className="collapse navbar-collapse flex-column" id="navbarNav">
					<hr className="d-md-none" />
					<ul className="nav nav-fill nav-pills bg-lg-dim rounded-max">
						<NavLink exact onClick={handleClick} to="/anticipa/events/majority" activeClassName="active" className="nav-item text-uppercase rounded-inherit ml-lg-0 w-auto flex-lg-grow-1">
							<div className="nav-link py-1 px-0" data-toggle="tooltip" data-placement="bottom" data-html="true" data-template='<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2 fs-2"></div></div>' title="Bientôt disponible">
								Passage majorité
							</div>
						</NavLink>
						<NavLink exact to="/anticipa/events/relocation" activeClassName="active" className="nav-item w-auto flex-lg-grow-1 text-uppercase rounded-inherit">
							<div className="nav-link py-1 px-0">Déménagement</div>
						</NavLink>
						<NavLink exact onClick={handleClick} to="/anticipa/events/marriage" activeClassName="active" className="nav-item w-auto flex-lg-grow-1 text-uppercase rounded-inherit">
							<div className="nav-link py-1 px-0" data-toggle="tooltip" data-placement="bottom" data-html="true" data-template='<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2 fs-2"></div></div>' title="Bientôt disponible">
								Mariage
							</div>
						</NavLink>
						<NavLink exact onClick={handleClick} to="/anticipa/events/birth" activeClassName="active" className="nav-item w-auto flex-lg-grow-1 text-uppercase rounded-inherit">
							<div className="nav-link py-1 px-0" data-toggle="tooltip" data-placement="bottom" data-html="true" data-template='<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2 fs-2"></div></div>' title="Bientôt disponible">
								Naissance
							</div>
						</NavLink>
						<NavLink exact onClick={handleClick} to="/anticipa/events/divorce" activeClassName="active" className="nav-item w-auto flex-lg-grow-1 text-uppercase rounded-inherit">
							<div className="nav-link py-1 px-0" data-toggle="tooltip" data-placement="bottom" data-html="true" data-template='<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2 fs-2"></div></div>' title="Bientôt disponible">
								Divorce
							</div>
						</NavLink>
					</ul>
					<hr className="d-md-none mb-0" />
				</div>
			</nav>
		</div>
	);
};
